import { STORE_NAME } from 'config/constants';
import { broadcast } from 'store/broadcast';
import { AuthLoadingSlice, createAuthLoadingSlice } from 'store/slices/createAuthLoadingSlice';
import { ClaimsAndReturnsSlice, createClaimsAndReturnsSlice } from 'store/slices/createClaimsAndReturnsSlice';
import { ConfiguratorSlice, createConfiguratorSlice } from 'store/slices/createConfiguratorSlice';
import { ContactInformationSlice, createContactInformationSlice } from 'store/slices/createContactInformationSlice';
import { createTransportAndPaymentSlice, TransportAndPaymentSlice } from 'store/slices/createTransportAndPaymentSlice';
import { createUserSlice, UserSlice } from 'store/slices/createUserSlice';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type PersistStore = AuthLoadingSlice &
    UserSlice &
    ContactInformationSlice &
    TransportAndPaymentSlice &
    ConfiguratorSlice &
    ClaimsAndReturnsSlice;

export const usePersistStore = create<PersistStore>()(
    persist(
        broadcast(
            (...store) => ({
                ...createAuthLoadingSlice(...store),
                ...createUserSlice(...store),
                ...createContactInformationSlice(...store),
                ...createTransportAndPaymentSlice(...store),
                ...createConfiguratorSlice(...store),
                ...createClaimsAndReturnsSlice(...store),
            }),
            STORE_NAME,
        ),
        { name: STORE_NAME, skipHydration: true },
    ),
);
